import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentPropsWithRef } from "react";
import type { AsChild } from "@/types";

const buttonVariants = cva("button", {
    variants: {
        variant: {
            default: "",
            link: "button--link",
            icon: "button--icon",
            action: "button--action",
        },
        background: {
            default: "",
            dark: "button--dark",
            accent: "button--accent",
        },
    },
    defaultVariants: {
        variant: "default",
        background: "default",
    },
});

type ComponentProps = ComponentPropsWithRef<"button">;
export type ButtonProps = ComponentProps & VariantProps<typeof buttonVariants> & AsChild;
export default function Button({ children, className, variant, background, asChild = false, ...props }: ButtonProps) {
    const Component = asChild ? Slot : "button";

    const defaultAttributes = {
        ...(!asChild && { type: "button" as const }),
    };

    return (
        <Component {...defaultAttributes} {...props} className={buttonVariants({ variant, background, className })}>
            {children}
        </Component>
    );
}
